import { Enum } from '../types';
import { MESSAGE_ID, MESSAGE_METHOD } from './constants';
import { ClosePlayerPayload, ErrorPayload, PostMessagePayload } from './types';

/**
 * Don't call this function directly. Use the player related message calls like closeGateViaPlayer or create a new one which internally calls this.
 */
const postMessage = (
  method: Enum<typeof MESSAGE_METHOD>,
  id: Enum<typeof MESSAGE_ID>,
  value?: PostMessagePayload,
) => {
  try {
    const targetOrigin = window?.document?.referrer ?? '*';
    if (targetOrigin) {
      console.info(method, ':', value);
      window.parent.postMessage({ method, id, value }, targetOrigin);
    } else {
      console.info(
        `targetOrigin is undefined, cannot post message: {${method}: ${JSON.stringify(value)}}`,
      );
    }
  } catch (e) {
    console.error('Error posting message', e);
  }
};

/**
 * All the player related message calls goes below here
 */

export const closeGateFromPlayer = (payload?: ClosePlayerPayload) => {
  postMessage(MESSAGE_METHOD.CLOSE_REMOTE_COMPONENT, MESSAGE_ID.ACCESS_GATE, payload);
};

export const reportErrorToPlayer = (payload?: ErrorPayload) => {
  postMessage(MESSAGE_METHOD.REPORT_REMOTE_COMPONENT_ERROR, MESSAGE_ID.ACCESS_GATE, payload);
};

export const setRemoteComponentReadyForPlayer = () => {
  postMessage(MESSAGE_METHOD.REMOTE_COMPONENT_READY, MESSAGE_ID.ACCESS_GATE);
};
